import { useGlobalState } from 'app/store'

export function useTranslation() {
  const [translations] = useGlobalState('translations')

  return (key: string) => {
    if (!translations[key]) {
      console.error(`Translation for key "${key}" does not exist`)
      return key
    }

    return translations[key]
  }
}
